import { MapPin } from "lucide-react";
import { ADDRESS_FULL, MSG, NAV_LINKS, PHONE_DISPLAY, wa } from "../../data/site";
import { LogoFull, WhatsAppIcon } from "./Icons";

export const Footer = () => (
    <footer data-testid="main-footer" className="border-t border-slate-200/70 bg-[#FAFCFF]">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
            <div className="lg:col-span-2">
                <LogoFull />
                <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-500">
                    Cirurgião-dentista especialista em Endodontia, dedicado ao diagnóstico e
                    tratamento de doenças da polpa dentária com microscopia operatória em Santos — SP.
                </p>
                <p className="mt-5 max-w-sm text-xs leading-relaxed text-slate-400">
                    As informações deste site têm caráter informativo e não substituem uma avaliação
                    odontológica individualizada.
                </p>
            </div>
            <div>
                <h3 className="font-heading text-sm font-bold uppercase tracking-[0.16em] text-slate-900">
                    Navegação
                </h3>
                <ul className="mt-5 space-y-3">
                    {NAV_LINKS.map((link) => (
                        <li key={link.href}>
                            <a
                                href={link.href}
                                data-testid={`footer-link-${link.href.slice(1)}`}
                                className="text-sm text-slate-500 transition-colors hover:text-[#1A6AFF]"
                            >
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <h3 className="font-heading text-sm font-bold uppercase tracking-[0.16em] text-slate-900">
                    Contato
                </h3>
                <ul className="mt-5 space-y-4 text-sm text-slate-500">
                    <li className="flex items-start gap-2.5">
                        <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#1A6AFF]" />
                        <span>{ADDRESS_FULL}</span>
                    </li>
                    <li>
                        <a
                            href={wa(MSG.consulta)}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp-link"
                            className="flex items-center gap-2.5 transition-colors hover:text-[#1EBE57]"
                        >
                            <WhatsAppIcon className="h-4 w-4 shrink-0 text-[#25D366]" />
                            {PHONE_DISPLAY}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div className="border-t border-slate-200/70 py-6">
            <p className="mx-auto max-w-7xl px-4 text-center text-xs text-slate-400 sm:px-6 lg:px-8">
                © {new Date().getFullYear()} Dr. Gabriel Riccio — Endodontista. Todos os direitos
                reservados.
            </p>
        </div>
    </footer>
);
